import { gql } from '@edreamsodigeo/frontend-api-client';

export const offerQuery = gql`
  query getPriceFreezeOffer($offerRequest: PriceFreezeOfferRequest!)
  @ignore_update {
    itineraryPriceFreezeOffer(offerRequest: $offerRequest) {
      offer {
        id
        expirationDate
        frozenPrimePrice {
          amount
          currency
        }
        deposit {
          amount
          currency
        }
        cap {
          amount
          currency
        }
      }
      searchCriteria {
        pax {
          numAdults
          numChildren
          numInfants
        }
      }
      itinerary {
        tripType
        legs {
          segments {
            carrier {
              id
              name
            }
            duration
            sections {
              transportType
              departureDate
              arrivalDate
              departure {
                name
                cityName
                countryCode
                iata
              }
              destination {
                name
                cityName
                countryCode
                iata
              }
            }
          }
        }
      }
      available
    }
  }
`;

export const multiOfferQuery = gql`
  query getPriceFreezeOffers($offerRequest: PriceFreezeOfferRequest!)
  @ignore_update {
    itineraryPriceFreezeOffers(offerRequest: $offerRequest) {
      offer {
        id
        expirationDate
        frozenPrimePrice {
          amount
          currency
        }
        deposit {
          amount
          currency
        }
        cap {
          amount
          currency
        }
        offerType
      }
      itineraryPriceFreezeItinerary {
        primePrice {
          amount
          currency
        }
        nonPrimePrice {
          amount
          currency
        }
        primeAndNonPrimePricesDifference {
          amount
          currency
        }
        numAdults
        numChildren
        numInfants
        type
        segments {
          referenceKey
          sections {
            duration
            departureDate
            arrivalDate
            departureLocation {
              name
              cityName
              countryCode
              iata
            }
            destinationLocation {
              name
              cityName
              countryCode
              iata
            }
            marketingCarrierCode
          }
        }
      }
    }
  }
`;

export const countryQuery = gql`
  query getCountries($getCountriesRequest: GetCountriesRequest!) {
    getCountries(getCountriesRequest: $getCountriesRequest) {
      countries {
        code
        id
        name
        phonePrefix
      }
    }
  }
`;

export const elegibilityQuery = gql`
  query isElegibleForPriceFreeze(
    $priceFreezeEligibilityRequest: PriceFreezeEligibilityRequest!
  ) {
    itineraryPriceFreezeEligibility(
      priceFreezeEligibilityRequest: $priceFreezeEligibilityRequest
    ) {
      isEligible
      expirationDays
    }
  }
`;

export const getMembershipAccountProperties = gql`
  query MembershipAccountProperties($email: String) {
    membershipAccountProperties(email: $email) {
      isActive
      isActiveLogged
    }
  }
`;

export const GET_USER = gql`
  query getUser {
    getUser {
      email
      travellers {
        personalInfo {
          name
          firstLastName
          secondLastName
        }
        buyer
        email
        prefixPhoneNumber
        phoneNumber
        prefixAlternatePhoneNumber
        mobilePhoneNumber
        alternatePhoneNumber
        isPrimeOwner
        address {
          address
          city
          country
        }
      }
    }
  }
`;
